import React from 'react';
import styled from 'styled-components';

const ContainerDiv = styled.div`
  position: relative;
  width: 100%;
  min-height: ${props => props.minHeight ? props.minHeight : '30vh'};
`;
const LoaderDiv = styled.div`
  position: absolute;
  top: calc(${props => props.top ? props.top : '50%'} - 3rem);
  left: calc(50% - 3rem);
  width: 6rem;
  height: 6rem;
  border: 1rem solid rgba(0, 0, 0, 0.2);
  border-left: 1rem solid #292c31;
  border-radius: 50%;
  animation: load360 1s infinite linear;
  @keyframes load360 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Loader = (props) => {
  return <ContainerDiv {...props}>
      <LoaderDiv {...props}/>
  </ContainerDiv>;
}

export default Loader;
